<template>
	<div class="bg-gray">
		<BaseNav></BaseNav>

		<div class="content">
			<div class="head-bg" :style="`background: url(${headBg}) no-repeat;backgroundSize:cover;`">
				<div class="container">
					<h2 class="text-white"></h2>
					<p class="text-white"></p>
				</div>
			</div>
		</div>

		<div class="container">
			<!-- 介绍 -->
			<div class="desc">
				<div class="title font-28 color-1a">关于我们</div>
				<div class="line"></div>
				<div class="content">
					<p>

            雄安股权交易所，位于河北省雄安新区，前身是河北股权交易所。2023年12月，正式更名为“雄安股权交易所”。是经河北省人民政府批准设立的河北省及雄安新区唯一一家区域性股权市场运营机构，是为河北省及雄安新区中小微企业私募证券发行、转让及相关活动提供设施与服务的场所，服务河北省经济结构转型升级和雄安新区发展。雄安股权交易所自2013年10月开市以来，搭建了涵盖上市培育、股票债券发行、股权登记托管、培训路演等方面的综合金融服务生态体系，助力河北省内一大批优质中小微企业蓬勃发展。10年来，雄安股权交易所先后运营对接沪深北证券交易所河北服务基地、国家中小企业公共服务示范平台、全省唯一一家推动企业股改上市的河北省股改上市服务平台、全省金融产权交易服务中心和河北省中小企业孵化服务中心；发起设立了全国首家省级创新型上市服务机构——河北省企业上市服务联盟；高质量建设“专精特新”专板，助力专精特新企业通过资本市场实现跨越式发展；建设多个特色板块，为河北省企业的高质量发展注入澎湃的金融动能。
          </p>
          <p style="margin-top: -18px">
            雄安股权交易所作为河北省企业上市服务联盟牵头单位、沪深北证券交易所河北服务基地和合作运营机构，引领国内知名头部券商等专业机构通过多种形式为企业提供股份制改造、上市培育等服务，并构建上下互联互通的上市通道，加快企业上市进程；综合运用股权、债券等直接融资工具，设计形成差异化的金融产品体系，为企业提供发行可转债、股权直接融资、股权质押融资等服务，拓宽企业融资渠道；依托登记托管职能，开展股权管理业务，帮助企业理顺股权结构、代理分红派息，为企业的长足发展提供支持；履行培训培育职能，开展资本培训和路演活动，搭建河北省中小企业孵化服务中心，为企业发展提供智力支持和资源对接；规范金融产权交易，开展不良资产转让业务，提升我省地方金融资源配置效率，防范化解金融风险。

          </p>
				</div>
			</div>
			<!-- 愿景 -->
			<div class="yj">
				<div class="content">
					<a-tabs default-active-key="1">
						<a-tab-pane key="1" tab="企业愿景">
							<p class="font-16" style="text-indent: 1cm;">
								建造一个资本赋能实体、平台链接企业的多层次资本市场塔基；	</p>
								<p class="font-16" style="text-indent: 2cm;">构筑一个数据驱动、要素齐全的新型资本生态圈层；	</p>
								<p class="font-16" style="text-indent: 3cm;">打造一个勇于创新、精于服务、国内一流的区域股权市场行业标杆。	</p>
						</a-tab-pane>
						<a-tab-pane key="2" tab="企业使命">
							<p class="font-16" style="text-indent: 1cm;">
								汇聚资本力量，创造专业价值，助力河北省经济高质量发展，为谱写中国式现代化建设河北篇章提供金融服务。
							</p>
						</a-tab-pane>
						<div slot="tabBarExtraContent">
							<img src="../../assets/yj_icon.png" alt="">
						</div>
					</a-tabs>
				</div>
			</div>
			<!-- 组织 -->
			<div class="zuzhi">
				<div class="title font-28 color-1a">组织架构</div>
				<div class="line"></div>
				<div class="content flex justify-center margin-top-30">
					<img width="90%" src="../../assets/about_zuzhi.png" alt="">
				</div>
			</div>
			<!-- 荣誉 -->
			<div class="rongyu">
				<div class="title font-28 color-1a">企业荣誉</div>
				<div class="line"></div>
				<div class="content">
					<div class="swiper-container">
						<div class="swiper-wrapper">
							<div class="swiper-slide" :data-index="index" v-for="(item,index) in swipers">
								<img :src="$api.baseUrl+$api.imgPath+item.imageUrl" alt="" width="330" height="221" style="padding-left: 20px;">
							</div>
						</div>

					 <!-- 如果需要导航按钮 -->
						<div class="swiper-button-prev" @click="changePrev"><</div>
						<div class="swiper-button-next" @click="changeNext">></div>

					</div>
					<div class="text-center font-24 color-1a margin-top-30">{{currentSwiperTitle}}</div>
					<div class="text-center font-16 color-1a margin-top-15">{{currentSwiperDesc}}</div>
				</div>
				<!-- 联系 -->
				<div class="lianxi">
					<div class="title font-28 color-1a">联系我们</div>
					<div class="line"></div>
					<div class="content">
						<div class="item">
							<img src="../../assets/about_phone.png" alt="">
							<div class="margin-top-15 font-18 color-1a">0311-68050800</div>
							<div class="margin-top-5">—— 联系电话 ——</div>
						</div>
						<div class="item-line"></div>
						<div class="item">
							<img src="../../assets/about_msg.png" alt="">
							<div class="margin-top-15 font-18 color-1a">hebotc@hebotc.com</div>
							<div class="margin-top-5">—— 电子邮箱 ——</div>
						</div>
						<div class="item-line"></div>
						<div class="item">
							<img src="../../assets/about_print.png" alt="">
							<div class="margin-top-15 font-18 color-1a">0311-68050210</div>
							<div class="margin-top-5">—— 传真号码 ——</div>
						</div>
					</div>
					<div class="location">
						<div class="item">
							<div class="icon"><img src="../../assets/about_map.png" alt=""></div>
							<div class="margin-left-5">
								<div class="location-item-title">公司地址</div>
								<div class="location-item-desc">河北省石家庄市桥西区维明大街1号钻石广场B座17-18楼。</div>
							</div>
						</div>
						<div class="item">
							<div class="icon"><img src="../../assets/about_car.png" alt=""></div>
							<div class="margin-left-5">
								<div class="location-item-title">交通方式</div>
								<div class="location-item-desc">市内乘坐一路、30路至维明中山路口（兴业银行）站下车即到。</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- map -->
			<div class="map">
				<div id="maper">

				</div>
			</div>
		</div>

		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
	import BaseNav from "@/components/BaseNavigation"
	import BaseFooter from "@/components/BaseFooter"
	import AMapLoader from '@amap/amap-jsapi-loader';

	export default {
		components: {
			BaseNav,
			BaseFooter
		},
		data() {
			return {
				headBg: "",
				map: null,
				swiperObj:null,
				currentSwiperTitle:"",
				currentSwiperDesc:"",
				swipers: [],
				menuPosition:""
			}
		},
		mounted() {
			document.title = "雄安股权交易所-关于我们";
			this.menuPosition = "1482177924603916289";
			this.getHeadBanner();
			this.getSwiper();
			this.initMap();

		},
		methods: {
			getHeadBanner(){
				this.$request({
					url:this.$api.public.getBanner,
					data:{
						menuPosition:this.menuPosition,
						type:1
					}
				}).then((res)=>{
					this.headBg = this.$api.baseUrl+this.$api.imgPath+res.data.result[0].pcImageUrl;
				})
			},
			// 初始化swiper插件
			initSwiperTools(){
				this.swiperObj = new Swiper('.swiper-container', {
					loop: true,
					// 如果需要分页器
					// pagination: '.swiper-pagination',
					// 如果需要前进后退按钮
					nextButton: '.swiper-button-next',
					prevButton: '.swiper-button-prev',
					slidesPerView:3,
					// 如果需要滚动条
					// scrollbar: '.swiper-scrollbar',
					//如果需要自动切换海报
					// autoplay: {
					//   delay: 1000,//时间 毫秒
					//   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
					// },
				})
			},
			// 获取荣誉数据
			getSwiper(){
				this.$request({
					url:this.$api.about.getSwiper
				}).then((res)=>{
					this.swipers = res.data.result;
					this.currentSwiperTitle = this.swipers[1].title;
					this.currentSwiperDesc = this.swipers[1].honnerContent;
					setTimeout(()=>{
						this.initSwiperTools();
					})
				})
			},
			changePrev(){
				let index = document.querySelector(".swiper-slide-next").dataset.index;
				this.currentSwiperTitle = this.swipers[index].title;
				this.currentSwiperDesc = this.swipers[index].honnerContent;
			},
			changeNext(){
				let index = document.querySelector(".swiper-slide-next").dataset.index;
				this.currentSwiperTitle = this.swipers[index].title;
				this.currentSwiperDesc = this.swipers[index].honnerContent;
			},
			initMap() {
				AMapLoader.load({
					key: "66ef8d0002100fc63dd8462f2f746fa9", // 申请好的Web端开发者Key，首次调用 load 时必填
					version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
					plugins: [''], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
				}).then((AMap) => {
					this.map = new AMap.Map("maper", { //设置地图容器id
						viewMode: "3D", //是否为3D地图模式
						zoom: 16, //初始化地图级别
						center: [114.470955, 38.042425], //初始化地图中心点位置
					});

					var marker = new AMap.Marker({
						position: new AMap.LngLat(114.470955,
						38.042425), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
						title: '雄安股权交易所'
					});

					this.map.add(marker);

					var infoWindow = new AMap.InfoWindow({
						anchor: 'bottom-center',
						content: '雄安股权交易所',
					});

					infoWindow.open(this.map, [114.470955, 38.042425]);

					// this.map.add(infoWindow);
				}).catch(e => {
					console.log(e);
				})


			},
		},
		setup() {
			return {
				map,
			}
		},
	}
</script>

<style scoped="scoped">
	.swiper-container{
	  width: 100%;
	  overflow-x: hidden;
	}

	.swiper-wrapper{
	}

	.swiper-button-prev:after{
	    display: none;
	}
	.swiper-button-next:after{
	    display: none;
	}

	.swiper-slide{
	  width: 338px;
	  height:221px;
	  line-height: 221px;
	  text-align: center;
	}

	.swiper-button-prev{
		width: 30px;
		height: 30px;
		background-image: none !important;
		border:1px solid #e6e9eb;
		background-color: #FFFFFF;
		line-height: 40px;
		text-align: center;
		border-radius: 4px;
		font-size:16px;
		color: #666;
		margin-left:-10px;

	}
	.swiper-button-next{
		width: 30px;
		height: 30px;
		background-image: none !important;
		background-color: #FFFFFF;
		border:1px solid #e6e9eb;
		line-height: 40px;
		border-radius: 4px;
		font-size:16px;
		text-align: center;
		color: #666;
		margin-right: -10px;
	}

	.swiper-button-next:hover{
		color: white;
		background-color: #13B8EE;
	}
	.swiper-button-prev:hover{
		color: white;
		background-color: #13B8EE;
	}
	.swiper-slide-next img{
		width: 330px;
		height: 221px;
	}

	.head-bg {
		width: 100%;
		height:300px;
	}

	.head-bg h2 {
		font-size: 36px;
		padding-top: 142px;
	}

	.head-bg p {
		font-size: 24px;
	}

	.bg-gray {
		background-color: #F5F5F5;
	}

	.line {
		width: 40px;
		height: 4px;
		background: #1C2C81;
		opacity: 1;
		border-radius: 0px;
		margin-left: auto;
		margin-right: auto;
		margin-top: 28px;
	}

	.container {
		box-shadow: 0px 0px 16px rgba(28, 44, 129, 0.08);
	}

	.desc {
		width: 100%;
		height: 494px;
		background-color: #FFFFFF;
		margin-top: -60px;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
		background-image: url(../../assets/about_desc_bg.png);
	}

	.desc .title {
		padding-top: 28px;
		text-align: center;
	}

	.desc .content {
		padding-left: 18px;
		padding-right: 18px;
		margin-top: 28px;
		font-size: 16px;
		text-indent: 1cm;
		line-height: 28px;
	}

	.yj {
		width: 100%;
		height: 244px;
		background-image: url(../../assets/about_3d.png);
		position: relative;
	}


	.yj .content {
		width: 828px;
		height: 263px;
		background: #FFFFFF;
		box-shadow: 0px 0px 16px rgba(28, 44, 129, 0.08);
		opacity: 1;
		border-radius: 8px;
		margin-left: 334px;
		position: absolute;
		top: 50px;
		padding: 40px;
	}

	.zuzhi {
		height: 1050px;
		background: #F5F5F5;
	}

	.zuzhi .title {
		padding-top: 140px;
		text-align: center;
	}

	.rongyu {
		height: 883px;
		background-color: #FFFFFF;
		position: relative;
	}

	.rongyu .title {
		padding-top: 80px;
		text-align: center;
	}

	.rongyu .content {
		margin-top: 40px;
		padding-left: 118px;
		padding-right: 118px;
	}

	.lianxi {
		width: 1100px;
		height: 436px;
		background: #FFFFFF;
		box-shadow: 0px 0px 16px rgba(28, 44, 129, 0.16);
		opacity: 1;
		border-radius: 16px;
		position: absolute;
		left:50px;
		bottom: -138px;
		z-index: 999;
	}

	.lianxi .title {
		padding-top: 50px;
	}

	.lianxi .content {
		display: flex;
		justify-content: space-between;
		margin-top: 40px;
	}

	.lianxi .content .item-line {
		width: 1px;
		height: 99px;
		background: #E6E6E6;
		opacity: 1;
		border-radius: 0px;
	}

	.lianxi .content .item {
		display: flex;
		flex-flow: column nowrap;
		align-items: center;
	}

	.lianxi .location {
		display: flex;
		justify-content: space-between;
		padding: 40px;
		margin-top: 30px;
		border-top: 1px solid #E6E6E6;
	}


	.lianxi .location .item {
		display: flex;
		align-items: center;
	}

	.lianxi .location .item .icon {
		background-color: rgba(44, 129, 255, 0.2);
		width: 40px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		border-radius: 12px;

	}

	.lianxi .location .item .location-item-desc {
		font-size: 16px;
		color: #1A1A1A;
	}

	.lianxi .location .item .title {
		background: none;
	}

	.lianxi .location .item .desc {}

	.map {
		width: 100%;
		height: 542px;
		margin-bottom: 30px;
	}

	.map #maper {
		width: 100%;
		height: 100%;
	}
</style>
<style>
	.ant-tabs-nav .ant-tabs-tab-active {
		color: #13B8EE;
	}

	.ant-tabs-nav .ant-tabs-tab {
		font-size: 18px;
	}

	.ant-tabs-nav .ant-tabs-tab:hover {
		color: #13B8EE;
	}

	.ant-tabs-ink-bar {
		background-color: #13B8EE;
	}
</style>



// WEBPACK FOOTER //
// src/pages/about/about.vue